import { motorActionTypes } from 'src/actions/actionTypes'

const initialState = {
  vehicleDetails: {
    isCompany: false,
    vehicleNumber: '',
    monthOfManufacturer: '',
    yearOfManufacturer: '',
    companyName: null,
    companyPAN: null,
    companyGSTIN: null,
    externalCngLpgKit: 'no',
    externalCngLpgKitAmount: '',
    isCurrentCarLoan: 'no',
    loanProviderName: '',
    branchName: '',
    carOwnedBy: '',
    engineNumber: '',
    chassisNumber: '',
    vehicleLogo: '',
    fuelType: '',
  },
  personalDetails: {
    name: '',
    mobileNumber: '',
    email: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    fullAddress: '',
    city: '',
    state: '',
    pincode: '',
    pan: '',
    aadhar: '',
  },
  previousPolicyDetails: {
    previousPolicyProvider: {},
    previousPolicyNumber: '',
    existingPolicyClaim: '',
    ncb: null,
    isPolicyExpired: '',
    expiryDate: '',
    expiredDate: '',
    isPolicyExpiredBeforeDate: '',
    thirdPartyExpiryDate: '',
    insuranceCompanyFirstName: '',
    thirdPartyProvider: '',
    thirdPartyPolicyNo: '',
    thirdPartyStartDate: '',
    thirdPartyProviderFirstName: '',
  },
  currentPolicyDetails: {
    idv: null,
    policyType: '',
    idvCover: '',
    paCover: true,
    paPremium: '',
    addOns: [],
    selectedAddOns: [],
  },
  selectedQuote: {},
  token: null,
  nomineeDetails: {
    nomineeFirstName: '',
    nomineeLastName: '',
    nomineeDOB: '',
    nomineeRelationType: '',
    nomineeGender: '',
  },
  isVehicleDetailsFetched: false,
}

const buyPolicyMotorReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case motorActionTypes.UPDATE_VEHICLE_DETAILS:
      return { ...state, vehicleDetails: action.payload }
    case motorActionTypes.UPDATE_PERSONAL_DETAILS:
      return { ...state, personalDetails: action.payload }
    case motorActionTypes.UPDATE_PREVIOUS_POLICY_DETAILS:
      return { ...state, previousPolicyDetails: action.payload }
    case motorActionTypes.UPDATE_CURRENT_POLICY_DETAILS:
      return { ...state, currentPolicyDetails: action.payload }
    case motorActionTypes.UPDATE_SELECTED_QUOTE:
      return { ...state, selectedQuote: action.payload }
    case motorActionTypes.UPDATE_TOKEN_MOTOR:
      return { ...state, token: action.payload }
    case motorActionTypes.UPDATE_NOMINEE_DETAILS:
      return { ...state, nomineeDetails: action.payload }
    case motorActionTypes.UPDATE_MOTOR_DETAILS:
      return { ...state, ...action.payload }
    case motorActionTypes.UPDATE_IS_VEHICLE_PREFILLED_DATA:
      return { ...state, isVehicleDetailsFetched: action.payload }
    default:
      return state
  }
}

export default buyPolicyMotorReducer
